import gql from 'graphql-tag'
import client from '@stores/apollo'
import { SpaceTypeFragment } from '@api/fragments'
import { ISpaceTypeWithCompany } from '@api/types'
import { InteractivityType } from './'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateSpaceType: { spaceType: ISpaceTypeWithCompany }
}

const mutateHandler = handleFetchResult<IPayload, ISpaceTypeWithCompany>({
  handler: (data) => data.updateSpaceType.spaceType,
  name: 'Space Type',
})

export default function update({
  id,
  name,
  interactivity,
  hidden,
}: {
  id: string
  name?: string
  interactivity?: InteractivityType
  hidden?: boolean
}) {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id, displayName: name, interactivity, hidden } },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation updateSpaceType($input: UpdateSpaceTypeInput!) {
    updateSpaceType(input: $input) {
      spaceType {
        ...SpaceTypeFragment
        company {
          id
        }
      }
    }
  }
  ${SpaceTypeFragment}
`
